module.exports = __webpack_public_path__ + "img/South-Korea.129b3cd5.png";